import reducer from "./reducer";
export { default as Projects } from "./components/index";
export { default as projectsReducerName } from "./constants";
export default reducer;
